import Svg from '@doordash/component-svg'
import * as React from 'react'

// tslint:disable:max-line-length
export const GetPaid: React.FunctionComponent = () => (
  <Svg
    width={286}
    height={254}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M31.5 165.726c18-25.3 45.1-54.1 29.9-70.5-36.7-39.7-37-90.9 19.3-85.8 10.1.9 29.599 9.4 38.599 14.6 50.5 29.3 64.1-38.1 102.6 2.4 37.4 39.4 1.9 98 41.9 108.4 56.3 17.2-9.4 118-54.9 117.3-56-.4-68.7 2-114.9.7-17.1-1.3-100.2-34-62.5-87.1z"
      fill="#E5F3F7"
    />
    <path
      d="M55 252.926h217.699"
      stroke="#3C5749"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M241.399 4.325s13.6 3.2 15.5 12.9c2 10-8.4 160.7-8.6 173.4-.2 13-.6 32.6-19 34.4"
      stroke="#838383"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M145.499 16.326l-9.2 186.9c-.3 11.3 6.6 17.7 13.8 18.7l74.3 3.5c9.8.6 18.3-4.6 18.8-14.401l9.5-189.7c.5-9.7-6.7-17.4-16.4-17.8l-73.6-3.5c-9.9-.5-16.8 6.4-17.2 16.3z"
      fill="#BAB9AA"
      fillOpacity={0.86}
    />
    <path
      d="M172.299 6.926s.3 8.2 7 9c4 .4 24.8 1.1 29.3 1.4 4.6.2 13.2.9 15.2-.9 2.7-2.5.9-5.8 2.5-6.2 1.4-.4 13.4-.5 16.5 2.4 3.3 3.1 4 6.8 3.5 13.2-.5 6.6-7.9 157.3-8.7 165.7-.8 8.4-.6 16.3-1.1 18.3-.7 2.8-2.8 8.1-10 8.4-7.3.4-69-3.7-73.6-3.6-6 .1-11.7-5.2-11-10.9.7-5.7 8.6-179.1 8.9-184.1.3-5 1.2-11.5 9.3-12.3 7.4-.9 12.2-.4 12.2-.4z"
      fill="#fff"
    />
    <path d="M172.799 210.325l36.4 1.5" stroke="#666" strokeMiterlimit={10} />
    <path
      d="M183.699 9.926c-1-.1-.7 1.3 0 1.5.7.2 26.5 1 27.4 1 .9 0 1.1-.9 0-1.2-.8-.3-25.1-1.1-27.4-1.3zm33.9 1.3c-.4.2-.4 1.1-.1 1.4.3.3 1.2.3 1.4-.4.2-.8-.7-1.4-1.3-1z"
      fill="#666"
    />
    <path
      opacity={0.49}
      d="M252.699 22.826l-10.4 186.8c-.7 9.6-6.4 15.1-12.5 16.7h-.2c2-22.9 11.5-217.8 11.7-220.9 7.5 2.2 11.9 9 11.4 17.4z"
      fill="#E6E5D7"
    />
    <path
      d="M171.199 60.126c-.3-.2-.7-.5-1-.7-.1-.1-.2-.1-.3-.2-.2-.1-.3-.1-.5-.2-.5-.2-1.1-.5-1.6-.8l-.6-.3c-.3-.2-.5-.4-.5-.8-.1-1 .9-1.9 1.9-1.6.8.2 1.5.6 2 1.2.2.3.4.3.6 0 .2-.2.3-.4.5-.6.4-.3.5-.7.2-1-.6-.6-1.2-1.3-2.1-1.6-.2-.1-.3-.2-.3-.4v-.7c0-.5-.2-.8-.7-.8-.2 0-.5 0-.7-.1-.4-.1-.6.1-.7.5 0 .3-.1.6-.1.9 0 .4-.1.5-.4.6-.4.2-.8.3-1.2.7-.4.4-.8.8-1.1 1.4-.4.8-.5 1.6-.5 2.5 0 .2.1.4.2.6.2.3.5.6.9.8.2.1.5.2.7.3.6.3 1.1.6 1.7.8.9.4 1.6 1 2.2 1.8.4.5.1 1.6-.5 1.8-.8.3-1.5.5-2.3.1-.4-.2-.7-.5-1.2-.5-.1 0-.1-.1-.2-.1-.3-.2-.7-.4-1-.6-.4.4-.7.8-1 1.2-.1.1-.1.2-.2.3-.2.3-.1.4.1.6.2.2.5.4.7.6.3.2.6.5 1 .7.4.1.8.2 1.1.3.2 0 .3.1.5.2 0 .5 0 1-.1 1.5.1.3.4.4.8.3h1.1c.1-.6.2-1.3.4-1.9.3-.1.6-.1.8-.2 1-.4 1.8-1 2.4-1.9.6-1 .8-2 .3-3.1-.1-.7-.7-1.2-1.3-1.6zm12.5.5c-.3-.2-.7-.5-1-.7-.1-.1-.2-.1-.3-.2-.2-.1-.3-.1-.5-.2-.5-.2-1.1-.5-1.6-.8l-.6-.3c-.3-.2-.5-.4-.5-.8-.1-1 .9-1.9 1.9-1.6.8.2 1.5.6 2 1.2.2.3.4.3.6 0 .2-.2.3-.4.5-.6.4-.3.5-.7.2-1-.6-.6-1.2-1.3-2.1-1.6-.2-.1-.3-.2-.3-.4v-.7c0-.5-.2-.8-.7-.8-.2 0-.5 0-.7-.1-.4-.1-.6.1-.7.5 0 .3-.1.6-.1.9 0 .4-.1.5-.4.6-.4.2-.8.3-1.2.7-.4.4-.8.8-1.1 1.4-.4.8-.5 1.6-.5 2.5 0 .2.1.4.2.6.2.3.5.6.9.8.2.1.5.2.7.3.6.3 1.1.6 1.7.8.9.4 1.6 1 2.2 1.8.4.5.1 1.6-.5 1.8-.8.3-1.5.5-2.3.1-.4-.2-.7-.5-1.2-.5-.1 0-.1-.1-.2-.1-.3-.2-.7-.4-1-.6-.4.4-.7.8-1 1.2-.1.1-.1.2-.2.3-.2.3-.1.4.1.6.2.2.5.4.7.6.3.2.6.5 1 .7.4.1.8.2 1.1.3.2 0 .3.1.5.2 0 .5 0 1-.1 1.5.1.3.4.4.8.3h1.1c.1-.6.2-1.3.4-1.9.3-.1.6-.1.8-.2 1-.4 1.8-1 2.4-1.9.6-1 .8-2 .3-3.1-.2-.7-.7-1.2-1.3-1.6zm36.1 75.999c-.3-.2-.5-.4-.8-.6-.1-.1-.2-.1-.2-.1-.1-.1-.2-.1-.4-.2-.4-.2-.9-.4-1.3-.6-.2-.1-.4-.2-.5-.3-.2-.2-.4-.4-.4-.6-.1-.8.8-1.5 1.5-1.3.6.2 1.2.5 1.6 1 .2.2.3.2.5 0 .1-.2.3-.3.4-.5.3-.3.4-.5.1-.8-.5-.5-.9-1.1-1.6-1.3-.2 0-.2-.1-.2-.3v-.6c0-.4-.1-.6-.5-.7-.2 0-.4 0-.6-.1-.3 0-.5.1-.6.4 0 .3-.1.5-.1.8 0 .3-.1.4-.4.5-.3.1-.7.3-1 .5-.3.3-.7.7-.9 1.1-.4.6-.5 1.3-.5 2 0 .2.1.4.1.5.2.3.4.5.7.6l.6.3c.5.2.9.5 1.4.7.7.3 1.3.8 1.7 1.5.3.4.1 1.3-.4 1.4-.6.2-1.3.4-1.9.1-.3-.1-.6-.4-1-.5-.1 0-.1-.1-.2-.1-.3-.2-.5-.4-.8-.5-.3.3-.6.7-.9 1l-.2.2c-.1.2-.1.3.1.5s.4.3.6.5c.3.2.5.5.8.6l.9.3c.1 0 .2.1.4.2 0 .4-.1.8-.1 1.2.1.2.3.3.6.3h.9l.3-1.5c.2-.1.5-.1.7-.2.8-.3 1.5-.8 2-1.5.5-.8.7-1.6.3-2.5.3-.6-.2-1-.7-1.4z"
      fill="#FF3008"
    />
    <path
      d="M153.999 121.925c-2.4.6-2.1 21.6-.8 22.2 1.3.5 75 5.7 77.1 5 2-.7 1.8-20.5.9-22-1-1.4-74.5-5.9-77.2-5.2zm9-46.299l29.3 1.2m-29.3 6.199l63.9 2.8m-65.8 11.6l39.5 1.8m-39.5 5.6l67.6 3.3"
      stroke="#C7C6B7"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M163.699 127.525c-.9 0-4.7.6-4.5 4.8.2 4.2 3 5.5 5 5.6 2 .1 5.4-1.2 5.6-4.6.1-2.2-1.2-6-6.1-5.8zm21.7 8.3c.5-.8 2.1-4.3-1.6-6.4-3.7-2.1-6.3-.5-7.4 1.1-1.2 1.6-2.1 5.5.8 7.2 1.9 1.2 5.7 2.3 8.2-1.9zm8.4 2.6c.6.7 3.3 3.4 6.6.7s2.6-5.7 1.5-7.4c-1.1-1.7-5.3-3.1-7-1.7-1.7 1.4-4.1 4.6-1.1 8.4z"
      stroke="#C7C6B7"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M210.399 144.126c1 1.2 8.1 4.9 13 .3 5.4-5 3.7-9.6 2-12.7-1.9-3.5-8.9-5.901-13-3.201-3.5 2.3-7.5 8.901-2 15.601z"
      stroke="#FF3008"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M166.899 41.626c.4.6.9 1.1 1.4 1.7.1.1.1.2.2.1.1 0 .2-.1.3-.2.4-.6.9-1.2 1.5-1.7.6-.6 1.1-1.3 1.6-2 0 2.3-.2 4.6-.1 6.9.3.2.7.1 1.1.1.4 0 .5-.2.5-.6v-1.9c0-1.4 0-2.7.1-4.1.1-1.1 0-2.2.1-3.4 0-.3-.2-.5-.4-.5h-.9c-.1 0-.2 0-.3.1-.3.3-.6.6-.8 1-.4.6-.9 1.2-1.3 1.8-.3.4-.6.8-1 1.2-.2.3-.3.3-.6 0l-.1-.1c-.2-.2-.4-.3-.5-.5-.6-.8-1.2-1.5-1.8-2.3-.3-.4-.6-.8-.8-1.2-.1-.2-.3-.4-.5-.4s-.5.1-.7.1c-.4 0-.5.1-.4.5v.7c0 .9 0 1.8-.1 2.7 0 1.3-.1 2.6-.1 3.9v2.3c0 .4.1.5.5.5.3 0 .6-.1.9-.1.4 0 .5-.1.5-.5v-6.5c.2.2.4.3.5.5l1.2 1.5c-.1.3 0 .4 0 .4zm28 5.8c.7.1 1.3-.2 1.9-.6.1 0 .1-.1.2-.1v.4c0 .4.1.5.4.5h.8c.5-.1.6-.2.6-.7V40.226c0-1 0-2-.1-3 0-.5-.1-.5-.5-.5h-.9c-.3 0-.4.1-.4.4 0 .7-.1 1.5-.1 2.2v.8c-.1 0-.1 0-.2-.1-.6-.3-1.6-.4-2.3-.2-.3.1-.6.2-.9.4-.3.2-.6.3-.8.6-.6.6-.9 1.4-1 2.3-.1 1.1.1 2.2.8 3.1.8.8 1.6 1.1 2.5 1.2zm-1-4.7c.1-.6.6-1 1.1-1.2.2-.1.4-.1.6-.1.5.1 1 .3 1.4.6.1.1.1.3.1.4.1.6.1 1.2.1 1.8 0 .1 0 .3-.1.4-.3.4-.6.8-1.2 1-.6.2-1 .1-1.5-.3-.8-.7-.7-1.6-.5-2.6zm7.2 4.1c.2.1.4.3.6.4.7.4 1.5.5 2.3.5.2 0 .5-.1.7-.2l.6-.3c.1.3.3.4.5.3h1.1c.1-.3.1-.5.1-.8 0-1 .1-2 .1-3 0-.3 0-.6-.1-.9l-.3-.9c-.1-.3-.2-.5-.4-.7-.3-.3-.6-.6-1-.8-.4-.2-.7-.3-1.1-.3h-.4c-.5-.1-1 .2-1.5.3h-.1c-.4.3-.8.4-1.1.7-.2.2-.3.4 0 .6l.6.6c.2.2.4.2.6 0 .2-.2.5-.3.7-.5.7-.4 1.6-.1 1.9.6-.2.1-.2.1-.3.3-.5.1-.9.2-1.3.3-.4.1-.7.1-1.1.2-.4.1-.8.3-1.1.6-.5.5-.5 1.1-.8 1.6v.1c.3.5.4 1 .8 1.3zm1.9-2.2c.6-.2 1.1-.4 1.7-.4h.2c.4-.1.4-.1.4.3 0 .3 0 .5-.2.7-.4.3-.8.6-1.2.8-.5.2-1.1-.1-1.3-.6 0-.3.1-.6.4-.8zm-16.8-4.6c-.2.1-.5.3-.7.4 0-.2-.1-.4-.1-.6h-1.4c-.1 0-.3 0-.3.2v1c0 .8.1 1.6.1 2.4 0 .1-.1.3 0 .4.1.6 0 1.2.1 1.8v.6c0 .3 0 .4.3.5.5.1.9.1 1.3-.2 0-1.2.1-2.4.1-3.6 0-.2 0-.3.1-.4.3-.4.8-.7 1.2-.9.3-.1.6-.1.9.2.2.2.3.4.5.7.1.1.1.3.1.4 0 .8.1 1.5.1 2.3-.1.5 0 1 0 1.6.3 0 .5.1.7.1.2 0 .4 0 .7-.1.3 0 .3-.1.3-.3v-2.1c0-.4.1-.8.1-1.3 0-.7-.1-1.4-.4-2.1-.3-.5-.6-1-1.2-1.2-.9-.2-1.7-.2-2.5.2zm-9.2-.301c-.6.3-1.1.7-1.5 1.3-.3.5-.6 1.1-.8 1.7-.1.3-.1.6 0 .8l.3.9c.2.4.3.9.6 1.2.8.7 1.7 1.3 2.8 1.2.4.1.9-.1 1.3-.3 1-.5 1.7-1.2 2.1-2.3.4-1 .5-2-.1-3-.4-.6-.9-1.1-1.4-1.4-.6-.4-1.3-.5-2-.4-.4.1-.9.1-1.3.3zm1.7 1.1c.4.1.9.1 1.2.5.4.4.7.9.7 1.4.1.9-.2 1.6-1 2.1-.3.2-.5.3-.8.4-.8.2-1.3-.1-1.8-.7-.3-.4-.5-.9-.4-1.4 0-.7.3-1.2.7-1.7.1-.1.3-.2.5-.3.2-.1.5-.2.7-.2.1-.1.2-.1.2-.1zm35.3-.199c-.3 0-.4.1-.5.3-.2.4-.3.8-.5 1.2-.3.7-.7 1.4-1 2.1-.1.2-.2.5-.3.7-.3 0-.3-.2-.4-.4-.2-.5-.4-1.1-.6-1.6-.2-.6-.4-1.2-.7-1.8 0-.1-.1-.2-.2-.3-.2-.1-.5-.1-.7-.2h-.7c-.1 0-.2.1-.2.1 0 .1-.1.3 0 .4.1.3.2.6.3 1 .3.6.5 1.3.8 1.9.1.4.3.7.4 1.1.1.3.2.7.4 1 .2.5.4.9.5 1.4v.3c-.2.7-.9 1.1-1.6 1.1-.3 0-.3 0-.4.3 0 .4 0 .8-.1 1.1 0 .1.1.2.1.2.3.1.7.1 1 .1.8-.1 1.4-.6 1.7-1.3.3-.6.6-1.3.9-2l1.2-2.7c.3-.6.6-1.3.9-1.9.1-.3.3-.5.5-.8.2-.3.4-.6.4-.9-.2-.4-.7-.4-1.2-.4z"
      fill="#63796D"
    />
    <path
      d="M166.499 118.625s-43.9-52.8-44.9-51.9c-1 1-41.7 35.4-41.7 35.4l42.8 49.1 43.8-32.6z"
      fill="#344C3F"
    />
    <path
      d="M65.5 62.925l-30.4 48.701 108.299 49.5 27.5-43-105.4-55.2z"
      fill="#3C5749"
    />
    <path
      d="M154.999 116.125l-87.1-44.5-23.2 36.5 31.9 16.8"
      stroke="#28362C"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M77.2 91.625c2.9.9 8.7 7.2 6.5 12.9-2.3 6.1-10 7.4-16.9 3.4-5.6-3.1-3.4-20.6 10.4-16.3z"
      fill="#536B5F"
    />
    <path
      d="M79.2 93.626c2.9.9 8.7 7.2 6.5 12.9-2.3 6.1-10 7.4-16.9 3.4-5.5-3.2-3.3-20.7 10.4-16.3z"
      stroke="#28362C"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M79.9 102.126s12-10.2 23.099-19.6l59.2 31c2.6 3.2 4.3 5.1 4.3 5.1l-43.9 32.6-42.7-49.1z"
      fill="#2D4337"
      fillOpacity={0.77}
    />
    <path
      d="M19.6 91.026l-11.7 55.4 142.299 21.5 9.5-51.7-140.1-25.2z"
      fill="#63796D"
      fillOpacity={0.94}
    />
    <path
      d="M40.3 112.026c2.9.9 8.7 7.2 6.5 12.9-2.3 6.1-10 7.4-16.9 3.4-5.6-3.2-3.4-20.7 10.4-16.3z"
      fill="#85968D"
    />
    <path
      d="M131.599 117.326l-107.7-19.1-7 34.3"
      stroke="#3C5749"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M42.8 113.225c2.9.9 8.7 7.2 6.5 12.9-2.3 6.1-10 7.4-16.9 3.4-5.5-3.1-3.4-20.7 10.4-16.3z"
      stroke="#3C5749"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M180.599 120.925c2.6 16.3 7.3 56.1 9.3 73 .6 4.8-5.5 8.6-5.5 8.6l-169.2 19.7s-7.2-1.5-7.6-5.3c-1.7-15.8-6.2-57.9-7.5-74.4-.3-3.9 2.1-7.5 6-8.1 27.9-4.6 139.5-17.3 166.8-20.1 3.9-.5 7 2.2 7.7 6.6z"
      fill="#BEDFE9"
    />
    <path
      d="M87.6 124.026c.7 5.6 10.9 88.9 10.9 88.9s-61.1 6.8-70.4 7.9c-9.3 1.1-8.3.9-8.3.9s-10.2-.2-11.1-4.3c-.9-4.1-8.1-71.8-8.6-74.6-.5-2.8.8-7.6 6-8.6 5.2-.9 81.5-10.2 81.5-10.2z"
      fill="#D2EDF3"
    />
    <path
      d="M76.3 143.425s.1-3.4-2.2-5c-2.9-1.9-8.1-1-15-.2-5.6.7-39.5 4.6-43.8 5.6-3.4.7-5.6 4.2-4.4 7.5 5.2-.4 65.4-7.9 65.4-7.9z"
      fill="#A6C7CE"
    />
    <path
      d="M78.4 157.925s.1-3.4-2.2-5c-2.9-1.9-8.1-1-15-.2-5.6.7-39.5 4.6-43.8 5.6-3.4.7-5.6 4.2-4.4 7.5 5.3-.3 65.4-7.9 65.4-7.9z"
      fill="#FF4926"
    />
    <path
      d="M80.2 172.225s.1-3.4-2.2-5c-2.9-1.9-8.1-1-15-.2-5.6.7-39.5 4.6-43.8 5.6-3.4.7-5.6 4.2-4.4 7.5 5.2-.3 65.4-7.9 65.4-7.9z"
      fill="#63796D"
    />
    <path
      d="M99.3 149.026c0 2 2.899 30 4.799 39.1.3 1.5 1.6 2.9 2.7 2.8 9.9 0 54.2-6.8 67-8.4 1.4-.2 3.4-2.2 2.9-5.4-1.5-9.4-3.2-28.8-4.6-36.2-.3-1.5-2.2-3.7-4.5-3.4-12.7 1.3-50.5 5.7-63.4 7.4-2.5.3-5 1-4.9 4.1z"
      fill="#fff"
    />
    <path
      d="M104.599 151.826c.1.6 3.9 30.7 3.9 30.7l30.6-3.3-4.1-30.7-30.4 3.3zm33.6-1.001l21.2-2.7m-20.5 7.101l13.6-1.8m10 20.299l8-.9m-30.3-8.999l17.1-2.1m-16.6 5.599l13.1-1.7m-12.7 5.201l12.8-1.9m7.4-21l6.9-1"
      stroke="#C7C6B7"
      strokeWidth={0.16}
      strokeMiterlimit={10}
    />
    <path
      d="M149.699 177.326s-.6 2.4 1.4 2c2-.4 2.2-2.9 4.9-2 2 .7 1.9 1.2 4.2 1.1 2.7-.1 4.4-2.1 4.3-2.9"
      stroke="#E5BBB7"
      strokeWidth={0.797}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M139.999 160.125l1 .4m-.1-.5l-.8.7m.3-.9l.2 1m1-.8l1 .3m-.2-.5l-.7.7m.3-.8l.1.9m2-.899l1 .4m-.2-.6l-.7.7m.3-.8l.1.9m1.1-.801l1 .4m-.2-.5l-.7.7m.2-.9l.2 1m2.2-1l1 .4m-.2-.5l-.7.7m.2-.8l.2.9m1-.9l1 .4m-.1-.499l-.8.7m.3-.801l.2.9m-6.9-.4l-.4 1.4m4.6-1.9l-.5 1.4"
      stroke="#C7C6B7"
      strokeWidth={0.16}
      strokeMiterlimit={10}
    />
    <path
      d="M158.699 159.426l1.4 12.2 11.7-1.5-1.6-12.1-11.5 1.4z"
      stroke="#EAE9E4"
      strokeWidth={0.16}
      strokeMiterlimit={10}
    />
    <path
      d="M116.899 171.725s2.2-.5 2.5-1.8c.3-1.3-.3-2.8-.3-2.8l3.9-.5s.3 2.9.8 3.2c.2.2.4.4.7.5 1.8.7 2.6 1 2.6 1s-1.8 1.1-5.1 1.7c-2.8.6-5.1-1.3-5.1-1.3z"
      fill="#A48276"
    />
    <path
      d="M116.399 161.626c-.1.4.9 4.2 1.2 5 .3.8 2.6 2.6 3.7 2.4 1.9-.2 2.8-2.8 3.2-3.8.3-.9 0-4.4-.1-5-.2-.6-6.5-1.3-6.5-1.3l-1.5 2.7z"
      fill="#B18F80"
    />
    <path
      d="M130.299 161.925c-.7-2.5-3.2-2.1-2.7-3.9.4-1.8 2.1-3.3.4-4.7-1.8-1.6-3-1.3-5.3-.2-3.3 1.5-3.3 2.101-4.4 2.101-.3 0-2.2-1.901-3.7-.701-1.4 1.1-1.6 2.1-1.1 4 .5 1.8 1.2 1.4-.5 4.1-1.7 2.7-4.1 4.401-1.6 6.101 1.6 1.2 5-.201 7.2-1.101-.7-.8-1.1-1.9-1.4-2.8-.3-1-.5-2.3-.5-2.3s1-.4 1.5-1.5c.3-.7.1-1.7.1-2.2 1.4 1.2 1.5 1.3 5.1 1 .9-.1 1.2.9.9 2.3-.2 1.1-.5 1.4.3 2.8-.4 1-.6 2.101-1.4 2.801 1.1.5 2.4.999 2.9.099.9-1.7.4-2.5 2.6-2.7 1.4-.2 2-1.6 1.6-3.2z"
      fill="#28362C"
    />
    <path
      d="M116.799 171.426s4.3 4 5.4 3.6c1.1-.4 2.6-4.6 2.6-4.6s5.8 1 7.4 2.7c.2.3 1 6.5 1 6.5l-22.2 2.6s-.7-6.3-.7-6.6c-.1-2.1 6.5-4.2 6.5-4.2z"
      fill="#FF836B"
    />
    <path
      d="M118.899 155.125s1.2.1 3.8-1.2c2-1 4.9-1.2 4.5.7-.2 1.3-.9 2.1.3 3.5 1.6 1.8 3.1 2.7 1.3 6.8m-10.8-9.9c-.8-.4-2.8.2-3.2 2.2-.4 2 1.5 3.1-1 4.6-3.2 2.1-2.9 3.5-2.1 5.2 1 2 2.8 2.4 2.8 2.4"
      stroke="#3C5749"
      strokeWidth={0.113}
      strokeMiterlimit={10}
    />
    <path
      d="M118.499 172.525s2.6 1.5 5.4-.2c-.3 2.4-.5 1.9-1.6 2.6-1.2.7-3.1-.6-3.4-1-.3-.3-.4-1.4-.4-1.4z"
      fill="#63796D"
    />
    <path
      d="M121.399 173.225l3.3 3.6s2.2-2.7 1.9-5.9l-1-1.1-4.2 3.4z"
      fill="#fff"
    />
    <path
      d="M121.499 173.125c-.1.2-2.9 4.5-2.9 4.5s-2.1-2.5-2.4-5.6c.7-.8 1-1 1-1l4.3 2.1z"
      fill="#fff"
    />
    <path
      opacity={0.33}
      d="M120.699 174.426c-1.7-1-3.8-3-3.8-3-.1.2-.3.4-.6.6.2 3.1 2.4 5.6 2.4 5.6s1.1-1.8 2-3.2zm2 .2l2 2.1s2.2-2.7 1.9-5.9l-.1-.1c-1-.2-1.6-.3-1.6-.3s-1.1 3.1-2.2 4.2z"
      fill="#F69271"
    />
    <path
      d="M116.499 163.225l8.2-.9m-4.5.601s.2 2.4-1.5 2.7c-1.6.2-2-2.3-2-2.3m7.6-.9s.2 2.4-1.5 2.7c-1.6.2-1.8-2.3-1.8-2.3"
      stroke="#FF3008"
      strokeWidth={0.131}
      strokeMiterlimit={10}
    />
    <path
      d="M135.399 182.025c-1.3-.9-2.3-2.3-2.8-3.9-1.2-4 1.1-8.2 5.2-9.4 4.1-1.2 8.3 1 9.5 5 .5 1.8.4 3.6-.3 5.1m-1.9 2.601c-.8.8-1.8 1.3-3 1.7-1.5.5-3.1.4-4.5 0"
      stroke="#63796D"
      strokeWidth={0.16}
      strokeMiterlimit={10}
    />
    <path
      d="M42.1 143.926l-27.9 3.5m29.3 11.5l-27.9 3.4m17.7 12.2l-15.2 1.8m18.1-2.201l16.6-2"
      stroke="#fff"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M166.499 133.425c-3.4.2-59.9 7.4-64.9 8-6 .7-6 3.7-5.8 6.4.2 2.8 2.5 29.2 3.6 35.1 1.1 6.3 1.4 11.3 7 11 2.8-.2 63-6.4 66-6.8 3-.4 9.1-.9 7.5-11.3-1.7-10.4-4.4-35.8-5.3-38.4-1.3-3.9-4.4-4.3-8.1-4z"
      stroke="#E5F3F7"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M81.9 142.825l-73.3 9m73.3 5.701l-73.3 9.1m74 5.199l-73.4 9"
      stroke="#fff"
      strokeWidth={0.493}
      strokeMiterlimit={10}
    />
    <path
      d="M84.9 172.726c0-.1.1.3.2 1"
      stroke="#fff"
      strokeWidth={0.4}
      strokeMiterlimit={10}
    />
    <path
      d="M85.3 175.626c.8 6.8 2.7 23.8 3.2 31.3.1 2-.4 4.2-1.6 4.4-11.3 2.3-66.7 7.5-69.2 7.7-2.5.2-4.5.2-5.2-2.4-.6-2.2-4.4-25.2-5.5-32.1"
      stroke="#fff"
      strokeWidth={0.4}
      strokeMiterlimit={10}
      strokeDasharray="1.97 1.97"
    />
    <path
      d="M7 183.626c-.1-.6-.2-1-.2-1"
      stroke="#fff"
      strokeWidth={0.4}
      strokeMiterlimit={10}
    />
    <path
      d="M89.1 127.326s77.799-9.2 81.799-9.5c6.2-.5 5.9 1.8 6.9 5.7 1 3.9 9 66.6 9.3 68.8.3 2.2-.4 6-4.5 7.3-4.1 1.4-84.3 10.1-84.3 10.1"
      stroke="#fff"
      strokeWidth={0.4}
      strokeMiterlimit={10}
      strokeDasharray="2 2"
    />
  </Svg>
)

export default GetPaid
